import {createSlice} from '@reduxjs/toolkit';

const productModalSlice = createSlice({
  name: 'productModal',
  initialState: {
    isOpen: false,
    productPaths: null,
    type: null,
    labels: null,
    defaultProductPath: null,
  },
  reducers: {
    openProductModal(state, action) {
      state.isOpen = true;
      state.productPaths = action.payload?.productPaths ?? null;
      state.type = action.payload?.type ?? null;
      state.labels = action.payload?.labels ?? null;
      state.defaultProductPath = action.payload?.defaultProductPath ?? null;
    },
    closeProductModal(state) {
      state.isOpen = false;
      state.productPaths = null;
      state.type = null;
      state.labels = null;
      state.defaultProductPath = null;
    },
  },
});

export const {openProductModal, closeProductModal} = productModalSlice.actions;

export const selectProductModalOpen = (state) => state.productModal.isOpen;
export const selectProductModalPaths = (state) => state.productModal.productPaths;
export const selectProductModalType = (state) => state.productModal.type;
export const selectProductModalLabels = (state) => state.productModal.labels;
export const selectProductModalDefaultProductPath = (state) => state.productModal.defaultProductPath;
export default productModalSlice.reducer;
